import {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {Avatar, Badge} from '@mui/material';
import {text} from '../text';
import {hooks} from '../hooks';
import {svg} from '../assets/svg';
import {theme} from '../constants';
import {RootState} from '../store';
import {actions} from '../store/actions';
import FavoriteIcon from '@mui/icons-material/Favorite';
import {TextField, InputAdornment} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {fetchCategories} from '../services/categoryService';
import SearchIcon from '@mui/icons-material/Search';
import {searchProducts} from '../services/searchService';
import {fetchNotifications} from '../services/notificationService';
import {fetchProfile} from '../services/authService';
import {Box, Grid, useTheme, useMediaQuery} from '@mui/material';
import {components} from '.';
type Props = {
  title?: string;
  line?: boolean;
  burger?: boolean;
  goBack?: boolean;
  basket?: boolean;
  navlink?: boolean;
  logo?: boolean;
};

export const Header: React.FC<Props> = ({
  line,
  title,
  burger,
  goBack,
  basket,
  navlink,
  logo,
}) => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [categories, setCategories] = useState<any[]>([]);
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const themeone = useTheme();
  const isMobile = useMediaQuery(themeone.breakpoints.down('sm'));
  useEffect(() => {
    const storedProfile = localStorage.getItem('profile');
    if (storedProfile) {
      setProfile(JSON.parse(storedProfile));
    } else {
      fetchProfile()
        .then((data) => {
          setProfile(data);
        })
        .catch((error) => {
          console.error('Error loading profile:', error);
        });
    }
  }, []);
  useEffect(() => {
    const loadCategories = async () => {
      try {
        setLoading(true);
        const categoriesData = await fetchCategories();
        setCategories(categoriesData);
      } catch (error) {
        console.error('Failed to load categories:', error);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, []);

  useEffect(() => {
    fetchNotifications()
      .then((data) => {
        setNotifications(data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (searchTerm.length >= 2) {
      searchProducts(searchTerm)
        .then((data) => {
          setSearchResults(data.data.data); // assuming your data is in the "data" field
          setShowResults(true);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setShowResults(false);
    }
  }, [searchTerm]);
  const handleNavigation = (path: string) => {
    setActiveTab(path);
    navigate(path);
  };
  const dispatch = hooks.useAppDispatch();
  console.log(notifications);
  useEffect(() => {
    if (modal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [modal]);

  const cart = hooks.useAppSelector((state: RootState) => state.cartSlice.list);
  const total = hooks.useAppSelector(
    (state: RootState) => state.cartSlice.total
  );

  const handleOnClick = () => {
    dispatch(actions.setScreen('Order'));
    navigate('/Order');
  };
  const renderLogo = (): JSX.Element | null => {
    if (logo) {
      return (
        <img
          src='/m&s_lgo.png' // Replace with your actual image path
          alt='Logo'
          width={20}
          height={20}
          style={{
            position: 'absolute',
            left: 0,
            padding: 20,
            cursor: 'pointer',
          }}
          onClick={() => navigate('/Home')}
        />
      );
    }

    return null;
  };

  const renderGoBack = (): JSX.Element | null => {
    if (goBack) {
      return (
        <button
          style={{position: 'absolute', left: 0, padding: 20}}
          onClick={() => navigate(-1)}
        >
          <svg.GoBackSvg />
        </button>
      );
    }

    return null;
  };
  const SearchBar = () => {
    return (
      <div style={{position: 'relative'}}>
        <TextField
          variant='outlined'
          placeholder='What are you looking for?'
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          label='Search'
          fullWidth
          style={{minWidth: isMobile ? 20 : 700}}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {showResults && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
              width: '100%',
              maxHeight: '300px', // Limit the height to make it scrollable
              overflowY: 'auto', // Enable vertical scrolling
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', // Flex into 2 columns
              gap: '10px',
              padding: '10px',
            }}
          >
            {searchResults.length > 0 ? (
              searchResults.map((item) => (
                <div
                  key={item.id}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    navigate('/product', {state: {item}});
                    setSearchTerm('');
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = '#FFD6D7')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = 'white')
                  }
                >
                  <img
                    src={item.attachments.product_main}
                    alt={item.name}
                    style={{width: '50px', marginRight: '10px'}}
                  />
                  {item.name}
                </div>
              ))
            ) : (
              <div
                style={{padding: '10px', textAlign: 'center', color: 'gray'}}
              >
                No items available
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // const renderBurger = (): JSX.Element | null => {
  //   if (burger) {
  //     return (
  //       <button
  //         style={{
  //           position: 'absolute',
  //           left: 0,
  //           padding: 20,
  //           cursor: 'pointer',
  //           backgroundColor: 'transparent',
  //           border: 'none',
  //         }}
  //         onClick={() => setModal(true)}
  //       >
  //         <svg.BurgerSvg />
  //       </button>
  //     );
  //   }

  //   return null;
  // };

  const renderTitle = (): JSX.Element => {
    return (
      <text.T16
        style={{
          marginTop: 80,
          left: '50%',
          textAlign: 'center',
          position: 'absolute',
          width: 'calc(100% - 100px)',
          transform: 'translateX(-50%)',
          color: theme.colors.mainColor,
        }}
      >
        {title}
      </text.T16>
    );
  };
  const renderAvatar = () => {
    if (profile) {
      const initials = profile.first_name[0] + profile.last_name[0];
      return (
        <Avatar
          alt='Profile'
          style={{
            marginTop: 5,
            position: 'absolute',
            right: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ccc',
            width: 40,
            height: 40,
            borderRadius: '50%',
            cursor: 'pointer',
          }}
          onClick={() => handleNavigation('/Profile')}
        >
          {initials}
        </Avatar>
      );
    } else {
      return (
        <Avatar
          alt='Default Profile'
          src='data:image/png;base64,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' // Replace with your default avatar image path
          style={{
            marginTop: 2,
            position: 'absolute',
            right: 10,
            cursor: 'pointer',
          }}
          onClick={() => handleNavigation('/SignIn')}
        />
      );
    }
  };
  const renderBasket = (): JSX.Element | null => {
    const unreadCount = notifications.filter((n) => !n.read_at).length;

    if (basket) {
      return (
        <>
          <button
            onClick={handleOnClick}
            style={{
              position: 'absolute',
              right: 40,
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 12,
            }}
          >
            <svg.BasketSvg />
            <div
              style={{
                padding: '3px 6px',
                borderRadius: 30,
                right: 40,
                bottom: 16,
                position: 'absolute',
                fontSize: 10,
                color: theme.colors.white,
                ...theme.fonts.DM_Sans_700Bold,
                backgroundColor: '#FF5B61',
              }}
            >
              {cart.length > 0 ? `€${total.toFixed(2)}` : '€0'}
            </div>
          </button>
          <button
            onClick={() => navigate('/wishlist')}
            style={{
              position: 'absolute',
              right: 130, // Position next to the Basket button
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 20,
              paddingRight: 20,
              borderRadius: 12,
            }}
          >
            <FavoriteIcon style={{color: theme.colors.coralRed}} />{' '}
            {/* Wishlist icon */}
          </button>
          <Badge
            badgeContent={unreadCount}
            color='warning'
            style={{
              position: 'absolute',
              right: 128,
              top: 32,
              cursor: 'pointer',
            }}
            onClick={() => {
              navigate('/notifications', {state: {notifications}});
            }}
          >
            <NotificationsIcon style={{color: theme.colors.coralRed}} />
          </Badge>
          {renderAvatar()}
        </>
      );
    }

    return null;
  };
  const rendermainlogo = (): JSX.Element | null => {
    if (basket) {
      return (
        <>
          <img
            src='https://i.postimg.cc/xdzRgc8v/m-s-lgo.png'
            alt='Logo'
            style={{
              width: '150px',
              height: '90px',
              marginRight: 'auto',
              left: 0,

              cursor: 'pointer',
            }}
            onClick={() => navigate('/Home')}
          />
        </>
      );
    }

    return null;
  };
  const renderNavLinks = (): JSX.Element | null => {
    if (loading) return null;

    const navLinkStyle = {
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: '10px',
      fontSize: '13px',
      transition: 'color 0.3s',
      position: 'relative' as const,
    };

    const activeStyle = {
      color: 'red', // Color when active
    };

    const handleNavigation = (path: string) => {
      setActiveTab(path);
      navigate(path);
    };

    const renderDropdownMenu = (category: any) => (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          backgroundColor: 'white',
          border: '1px solid #ccc',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          width: '200px',
          opacity: hoveredTab === category.name ? 1 : 0,
          transform:
            hoveredTab === category.name
              ? 'translateY(0)'
              : 'translateY(-10px)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
          pointerEvents: hoveredTab === category.name ? 'auto' : 'none',
        }}
      >
        <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
          {category.child.map((subCategory: any) => (
            <li
              key={subCategory.id}
              style={{
                padding: '10px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
              }}
              onClick={() => {
                setActiveTab(category.name);
                localStorage.setItem('childId', subCategory.id);
                navigate('/shop', {
                  state: {
                    products: category,
                    childId: subCategory.id,
                    title: 'Shop',
                  },
                });
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#FFD6D7')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = 'white')
              }
            >
              {subCategory.name}
            </li>
          ))}
        </ul>
      </div>
    );

    return (
      <nav
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '50px',
          position: 'relative',
          // overflowX: isMobile ? 'auto' : 'unset', // Enable horizontal scroll on mobile
          // whiteSpace: isMobile ? 'nowrap' : 'normal', // Prevent text wrapping on mobile
        }}
      >
        {/* Add Home button as a constant */}
        <div
          style={{position: 'relative'}}
          onMouseEnter={() => setHoveredTab('Home')}
          onMouseLeave={() => setHoveredTab(null)}
        >
          <button
            style={{
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: '10px',
              fontSize: '14px',
              fontWeight:
                hoveredTab === 'Home' || activeTab === 'Home'
                  ? 'bold'
                  : 'normal',
              color:
                activeTab === 'Home'
                  ? 'red'
                  : hoveredTab === 'Home'
                  ? 'red'
                  : 'black',
              position: 'relative',
            }}
            onClick={() => handleNavigation('/home')} // Navigate to home
          >
            Home
            <span
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                height: '2px',
                backgroundColor: 'red',
                width:
                  hoveredTab === 'Home' || activeTab === 'Home' ? '100%' : '0%',
                transition: 'width 0.3s ease',
              }}
            />
          </button>
        </div>

        {/* Render other category links */}
        {categories.map((category) => (
          <div
            key={category.id}
            style={{position: 'relative'}}
            onMouseEnter={() => setHoveredTab(category.name)}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <button
              onClick={() => {
                navigate('/shop', {
                  state: {products: category, title: 'Shop'}, // Adjust this as needed
                });
              }}
              style={{
                cursor: 'pointer',
                background: 'none',
                border: 'none',
                padding: '10px',
                fontSize: '14px',
                fontWeight:
                  hoveredTab === category.name || activeTab === category.name
                    ? 'bold'
                    : 'normal',
                color:
                  activeTab === category.name
                    ? 'red'
                    : hoveredTab === category.name
                    ? 'red'
                    : 'black',
                position: 'relative',
              }}
            >
              {category.name}
              <span
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  height: '2px',
                  backgroundColor: 'red',
                  width:
                    hoveredTab === category.name || activeTab === category.name
                      ? '100%'
                      : '0%',
                  transition: 'width 0.3s ease',
                }}
              />
            </button>

            {hoveredTab === category.name && renderDropdownMenu(category)}
          </div>
        ))}
      </nav>
    );
  };
  const headerStyle: React.CSSProperties = {
    top: 0,
    height: 52,
    width: '100%',
    position: 'fixed',
    zIndex: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.white,
    borderBottom: line ? `1px solid ${theme.colors.aliceBlue2}` : 'none',
    padding: '0 20px',
  };

  return (
    <header
      style={{
        top: 0,
        width: '100%',
        zIndex: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px 10px',
        backgroundColor: 'white',
        position: 'fixed',
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Grid
        container
        alignItems='center'
        justifyContent='space-between'
        sx={{width: '100%'}}
      >
        <Grid item>{rendermainlogo()}</Grid>

        {/* Only show search bar in this location on larger screens */}
        {!isMobile && (
          <Grid item xs={6} sx={{display: 'flex', justifyContent: 'center'}}>
            {SearchBar()}
          </Grid>
        )}

        <Grid item sx={{mt: -9}}>
          {renderBasket()}
        </Grid>
      </Grid>

      {/* Navigation and title section */}
      <Grid container alignItems='center' sx={{width: '100%'}}>
        <Grid item>{renderGoBack()}</Grid>
        <Grid item>{renderLogo()}</Grid>

        {/* Conditionally hide navigation links on mobile */}
        {!isMobile && <Grid item>{renderNavLinks()}</Grid>}

        <Grid item>{renderTitle()}</Grid>
      </Grid>

      {/* Mobile-only search bar at the bottom */}
      {isMobile && (
        <Box sx={{width: '80%', marginTop: '10px'}}>
          {SearchBar()} {/* Display search bar at the bottom on mobile */}
        </Box>
      )}
    </header>
  );
};
